/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {CampModel} from '../../../../model'
import {getCamp} from '../../../../services'
import {useSite, useClient, useCompany} from '../../../../hooks'
const TableCamp: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, changeSearchValues, clearSearchValues} = useKhipu()
  const {siteList, getSiteList, handleClear: handleClearSite} = useSite()
  const {clientList, getClientList, handleClear} = useClient()
  const {companyList, getCompanyList} = useCompany()
  const getCampList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getCamp(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCompanyList()
    getClientList()
    getSiteList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getCampList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getCampList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-camp',
      },
      idToEdit: getData.id,
      idToDelete: '',
    }
    clearSelected()
    changeCurrentTabItem(obj)
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const handleFilterCamp = (e: any, name: string) => {
    let value = e.value
    const {CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }
  const columns: Column<CampModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            data={companyList}
            selecteable
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'clienteId'}
            data={clientList}
            selecteable
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            onGetValueSelect={handleFilterCamp}
            name={'siteId'}
            data={siteList}
            selecteable
          />
        ),
        accessor: 'site',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Campamento' name={'nombre'} searcheable />
        ),
        accessor: 'nombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [companyList, clientList, siteList, selectedOn],
  )

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getCampList()
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getCampList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      handleClearSite()
      handleClear()
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />

          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

export {TableCamp}
